export const TAG_ID = "data-tag-id";
export const TAG_ZONE_ID = "data-tag-zone-id";

const getTagIdFor = (id: string) => {
    return {
        [TAG_ID]: id
    };
};

const getTagZoneIdFor = (id: string) => {
    return {
        [TAG_ZONE_ID]: `zone-${id}`
    };
};

export { getTagIdFor, getTagZoneIdFor };
